import { useState, useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import JsonData from "./data/data.json";

import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Navigation } from "./components/navigation";
import Home from "./Home";
import { Footer } from "./components/footer";
import Footerdetail from "./components/Footerdetail";
import { Privacypolicy } from "./components/pages/privacypolicy";
import { initUserInteractionTracking } from "./userInteraction";
import { Patna } from "./components/location/Patna";



export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});


const App = () => {
  

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
     initUserInteractionTracking();
  }, []);

  return (
    <div>
    
      <div className='social'>
        {/*
        <div>
          <a className="whatsapp" href="https://api.whatsapp.com/send?phone=919403893810" target="_blank">
            <i className="fa fa-whatsapp"></i>
          </a>
        </div>  
        */}
        <div className="pop">
          <a className="phonescreen" href="tel:9403893810 ">
            <img style={{ border: "0" }} src="img/banners/quickenquiry2.png" alt="callus@9403893810 " />
          </a>
        </div>
      </div>
      <Navigation />

      <Routes>
        <Route exact path="/" element={<Home />} />
        
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/ro-water-purifier-service-patna" element={<Patna />} />
        

        </Routes>
      
      <Footerdetail data={landingPageData.Contact} />
      <Footer data={landingPageData.Footer} />
    </div>

  );
};


export default App;

